window.VegasCatalog.Order = {
	make: function ($form, callback) {
		let route = $form.attr('action');
		let params = $form.serializeArray();

		$.post(route, params, function (data) {
			if (callback) {
				callback(data);
			}
		})
	},

	CDEK: {
		cdekWidget: null,
		init: function () {
			if (VegasCatalog.Order.CDEK.cdekWidget) return;
			if (typeof ISDEKWidjet == 'undefined') return;

			VegasCatalog.Order.CDEK.cdekWidget = new ISDEKWidjet({
				//defaultCity: 'auto',
				hidedress: true,
				cityFrom: 'Калуга',
				hidedelt: true,
				popup: true,
				apikey: App.mapKey,
				suggest_apikey: App.suggestMapKey
			});

			VegasCatalog.Order.CDEK.cdekWidget.binders.add(function (wat) {
				var address = [
					wat.cityName,
					wat.PVZ.Address + ", ПВЗ #" + wat.id
				].join(', ');
				$("#user_address-cdek").val(address);
				$('.user_address_cdek').html(address);
			}, 'onChoose');

			VegasCatalog.Order.CDEK.cdekWidget.binders.add(function (wat) {
				var address = [
					wat.cityName,
				].join(', ');
				$("#user_address-cdek").val(address);
				$('.user_address_cdek').html(address);
			}, 'onChooseProfile');
		},
		open: function () {
			VegasCatalog.Order.CDEK.cdekWidget.open();
		},
	},

	Courier: {
		init: function () {
			let $userAddressCourier = $("#user_address_courier");
			let validCourierAddresses = [$userAddressCourier.data('validaddress')];
			let $mapAddress = $("#map-courier-address");

			setTimeout(function () {
				if (typeof ymaps !== 'undefined' && $mapAddress.length) {
					let $userAddressCourier = $("#user_address_courier");

					ymaps.ready(function () {
						let suggestView = new ymaps.SuggestView("user_address_courier");

						suggestView.events.add('select', function (e) {
							let addr = $.trim(e.get('item').value);
							validCourierAddresses.push(addr);
							$userAddressCourier.attr('data-old-addr', '');

							ymaps.geocode(e.get('item').value, {results: 1}).then(function (res) {
								var firstGeoObject = res.geoObjects.get(0),
									coordinates = firstGeoObject.geometry.getCoordinates();

								$("#form-cart").find('[name=user_address_courier_coordinates]').val(coordinates);

								VegasCatalog.Order.Courier.updatePrice();
							});
						});

						if ($userAddressCourier.length && $userAddressCourier.val()) {
							ymaps.geocode($userAddressCourier.val(), {results: 1}).then(function (res) {
								var firstGeoObject = res.geoObjects.get(0),
									coordinates = firstGeoObject.geometry.getCoordinates();

								$("#form-cart").find('[name=user_address_courier_coordinates]').val(coordinates);

								VegasCatalog.Order.Courier.updatePrice();
							});
						}
					});

					$userAddressCourier.on('blur', function () {
						let self = this;

						setTimeout(function () {
							let currentAddress = $(self).val();
							if (currentAddress) {
								let valid = false;
								for (let i in validCourierAddresses) {
									let validAddr = validCourierAddresses[i];
									if (!validAddr) continue;
									if (currentAddress.indexOf(validAddr) !== -1) {
										valid = true;
										break;
									}
								}

								if (!valid) {
									$(self).attr('data-old-addr', $(self).val());
									$(self).val('');
									alert('Выберите адрес из выпадающего списка!');
								}
							}
						}, 150);
					}).on('focus', function () {
						let addr = $(this).attr('data-old-addr');
						if (addr) {
							$(this).val(addr);
						}
					});

					$userAddressCourier.on('update-price', VegasCatalog.Order.Courier.updatePrice);
				}
			}, 1000);
		},

		updatePrice: function () {
			VegasCatalog.Cart.updateTotalAll();
		}
	}
};

$(document).ready(function () {
	let $formOrder = $("#form-cart");

	VegasCatalog.Order.CDEK.init();
	VegasCatalog.Order.Courier.init();

	$formOrder.find('[name=delivery_id]').on('change', function () {
		let id = $(this).attr('id'),
			val = parseInt($(this).val()),
			$containerOrder = $(this).closest('.vg-catalog-cart--totals'),
			$containerDelivery = $containerOrder.find('.delivery-area--placement');

		// set show & active
		$containerDelivery.find('.active').removeClass('show active');
		let $currentDelivery = $containerDelivery.find('[data-id=' + id + ']');
		$currentDelivery.addClass('show active');

		// use required
		$('.delivery-area--placement .toggle-required').removeAttr('required');
		$currentDelivery.find('.toggle-required').attr('required', 'required');

		if (val === 3) {
			VegasCatalog.Order.CDEK.open();
		}

		VegasCatalog.Cart.updateTotalAll();
	});

	$formOrder.find('.select-cdek-address').click(function () {
		VegasCatalog.Order.CDEK.open();
		return false;
	});

	$formOrder.find('[name=pek_id]').change(function () {
		VegasCatalog.Cart.updateTotalAll();
	});

	$formOrder.find('[name=dellin_id]').change(function () {
		VegasCatalog.Cart.updateTotalAll();
	});

	$formOrder.submit(function () {
		$('.vg-catalog-cart--preload').addClass('show');

		VegasCatalog.Order.make($formOrder, function (data) {
			if (data.error) {
				alert(data.msg);
				$('.vg-catalog-cart--preload').removeClass('show')
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$formOrder.on("keydown", function(event) {
		return event.key != "Enter";
	});
});
